module.exports = __webpack_public_path__ + "img/silicium-high-purity.504952c2.png";